import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PaymentComponent } from './payment.component';
import { PaymentSummaryComponent } from './payment-summary.component';
import { TranslateModule } from '@ngx-translate/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DialogModule } from '@angular/cdk/dialog';
import { PaymentService } from './payment.service';
import { PaymentResponseModule } from '../paymentResponse/paymentResponse.module';
import { A11yModule } from "@angular/cdk/a11y";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    declarations: [
        PaymentComponent,
        PaymentSummaryComponent
    ], 
    imports: [
        CommonModule,
        FormsModule,
        DialogModule,
        TranslateModule,
        PaymentResponseModule,
        A11yModule,
        MatProgressSpinnerModule
    ], 
    providers: [
        PaymentService, 
        provideHttpClient(withInterceptorsFromDi())
    ]
})

export class PaymentModule { }